import { render } from "./GSAuthorize.vue?vue&type=template&id=849adcec"
import script from "./GSAuthorize.vue?vue&type=script&lang=js"
export * from "./GSAuthorize.vue?vue&type=script&lang=js"
script.render = render

export default script